import { render, staticRenderFns } from "./bind-code.vue?vue&type=template&id=62fb1426&"
import script from "./bind-code.vue?vue&type=script&lang=js&"
export * from "./bind-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports